import React from "react";
import PropTypes from "prop-types";
import { followedContentErrorViewModel } from "../../../constants/followedContent-error-viewModel";

import { Type } from "discover.medical.react-component-library";

const FollowedContentErrorMessage = ({ error }) => (
  <>
    <Type>{error.name}</Type>
    <Type>{error.message}</Type>
  </>
);

FollowedContentErrorMessage.propTypes = {
  error: PropTypes.shape({
    name: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
  }),
};

FollowedContentErrorMessage.defaultProps = {
  error: followedContentErrorViewModel.error,
};
FollowedContentErrorMessage.displayName = "FollowedContentErrorMessage";
export default FollowedContentErrorMessage;
